/* global femcare */

femcare.shared.heroSlider = {
    init: function () {
        $('.hero-slide').heroSlide({
            youtubeVideoSelector: '.js-youtube-embed',
            mediabankVideoSelector: '.media-hero__video',
            movablePanelSelector: '.hero-slide__panel',
            panelActiveClass: 'hero-slide__panel--move'
        });

        $('.hero-slider').heroSlider({
            slideSelector: '.hero-slide',
            sliderSelector: '.hero-slider__slider',
            freezeSliderClass: '.hero-slider__slider--freeze',
            nextButtonSelector: '.hero-slider__next',
            previousButtonSelector: '.hero-slider__previous',
            pagionationSelector: '.hero-slider__pagination',
            bulletClass: 'hero-slider__page',
            bulletActiveClass: 'hero-slider__page--active',
            titleSelector: null,
            overlaySelector: '.hero__overlay'
        });

    }
};